module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('h1', [_vm._v("shades")]), _vm._v(" "), _c('section', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    attrs: {
      "type": "text",
      "placeholder": "shade search"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.filteredShades), function(details) {
    return _c('Expandable', {
      key: details.productId,
      attrs: {
        "name": details.productName[_vm.$t('trad')].value
      }
    }, [_c('ul', _vm._l((details.shades), function(shade) {
      return _c('ShadeListTile', {
        key: shade.id,
        attrs: {
          "shade": shade,
          "selected": _vm.shadeSelected && shade.id === _vm.shadeSelected.id
        },
        on: {
          "selectShade": _vm.selectShade
        }
      })
    }))])
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-121f7055","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/plano/edits/edit_board_module/shades-catalog.vue
// module id = 3024
// module chunks = 0